document.addEventListener("DOMContentLoaded", function () {

  const birthday = document.getElementById("birthday");
  const ageResult = document.getElementById("age-result");
  const guardianBox = document.getElementById("guardian-box");
  const guardianName = document.getElementById("guardian-name");

  const firstDate = document.getElementById("first-date");
  const secondDate = document.getElementById("second-date");

  const note = document.getElementById("booking-note");
  const remain = document.getElementById("remain-count");

  // -------------------------
  // 今日以前は選択不可
  // -------------------------

  const today = new Date();
  today.setHours(0,0,0,0);

  const yyyy = today.getFullYear();
  const mm = String(today.getMonth()+1).padStart(2,"0");
  const dd = String(today.getDate()).padStart(2,"0");

  const todayText = `${yyyy}-${mm}-${dd}`;

  if(firstDate){
      firstDate.min = todayText;
  }

  if(secondDate){
      secondDate.min = todayText;
  }

  // -------------------------
  // 第一希望日変更
  // -------------------------

  if(firstDate){

      firstDate.addEventListener("change",function(){

          secondDate.min = this.value;

          if(secondDate.value < this.value){

              secondDate.value = "";

          }

      });

  }

  // -------------------------
  // 年齢自動計算
  // -------------------------

  if(birthday){

      birthday.addEventListener("change",function(){

          const birth = new Date(this.value);

          let age = today.getFullYear() - birth.getFullYear();

          const m = today.getMonth() - birth.getMonth();

          if(m < 0 || (m===0 && today.getDate() < birth.getDate())){

              age--;

          }

          ageResult.innerHTML = age;

          if(age < 18){

              guardianBox.style.display="block";

              guardianName.required=true;

          }else{

              guardianBox.style.display="none";

              guardianName.required=false;

          }

      });

  }

  // -------------------------
  // 残り文字数
  // -------------------------

  if(note){

      note.addEventListener("input",function(){

          remain.innerHTML = 500 - this.value.length;

      });

  }

  // -------------------------
  // チーム切替
  // -------------------------

  const team = document.getElementById("booking-team");
  const preview = document.getElementById("team-preview");
  const image = document.getElementById("team-image");
  const description = document.getElementById("team-description");

  if(team){

      team.addEventListener("change",function(){

          const option = this.options[this.selectedIndex];

          const img = option.dataset.image;
          const text = option.dataset.description;

          if(img){

              preview.style.display="block";

              image.src = img;

          }else{

              preview.style.display="none";

          }

          description.innerHTML = text || "";

      });

  }

});

// ------------------
// 必須チェック
// ------------------

const form=document.querySelector('form[action="/cart/add"]');

if(form){

form.addEventListener("submit",function(e){

let error="";

const team = document.getElementById("booking-team");

if(team){

team.addEventListener("change",function(){

const option=this.options[this.selectedIndex];

const image=option.dataset.image;

const text=option.dataset.description;

const preview=document.getElementById("team-preview");

const img=document.getElementById("team-image");

const desc=document.getElementById("team-description");

if(image){

img.src=image;

preview.style.display="block";

}else{

preview.style.display="none";

}

desc.innerHTML=text;

});

}

if(firstDate.value==""){

error="第一希望日を入力してください";

}

if(document.querySelector('[name="properties[氏名]"]').value==""){

error="氏名を入力してください";

}

if(document.querySelector('[name="properties[国籍]"]').value==""){

error="国籍を入力してください";

}

if(birthday.value==""){

error="生年月日を入力してください";

}

if(guardianBox.style.display=="block"){

if(guardianName.value==""){

error="保護者氏名を入力してください";

}

}

if(error!=""){

e.preventDefault();

alert(error);

}

});

}